// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ygbkTXBXF0PhToAdYYaC {
  padding: 12px;
  padding-bottom: 2px;
  width: calc(100% - var(--width-sidebar));
  border-radius: 20px;
  border-bottom-right-radius: 0px;
  background-color: #fff;
}

.Lr9TWq6bT4s8OQpG63cU {
  width: 275px;
  text-align: end;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
}

/* .wrapper.mobile {
    margin: 0 auto;
    width: 100%;
    padding: 0;
    max-height: calc(100vh - 66px);
} */
.ygbkTXBXF0PhToAdYYaC.AhtQy7h_iVgVXdIACfqi.kesPQUxVsflEaVyl4p8p {
  padding-bottom: 20px;
}

.YbiLv3VWhKzK9zhLcgbY {
  background-color: var(--red);
  color: var(--white);
  font-size: 14px;
  /*font-weight: 700;*/
  height: 60px;
  margin: 10px auto;
  width: 374px;
  display: block;
}

.stM99AFwYkqu4YcwtEbU {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 100%;
  /* min-width: 660px; */
  border-radius: 5px;
  z-index: 0;
}

.U2v2fPUliNEE_FIVpeJv {
  background-color: var(--white);
  color: var(--red);
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 195px;
  height: 60px;
  border: 1px solid var(--red);
  border-radius: 5px;
  margin: 10px 10px 10px 10px;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  padding: 0 42px;
}
.stM99AFwYkqu4YcwtEbU:has(.U2v2fPUliNEE_FIVpeJv:only-child) {
  justify-content: end;
}

.U2v2fPUliNEE_FIVpeJv {
  padding: 0 20px;
  min-width: 155px;
}

.css8Tcbnd_w80ZljjI81 {
  position: relative;
  width: 30px;
  height: 20px;
}
.css8Tcbnd_w80ZljjI81 div {
  border-top: 2px solid var(--red);
}
.css8Tcbnd_w80ZljjI81 div::before {
  content: "";
  border-top: 2px solid var(--red);
  width: 20px;
  position: absolute;
  top: 10px;
  left: 0;
}
.css8Tcbnd_w80ZljjI81 div::after {
  content: "";
  border-top: 2px solid var(--red);
  width: 10px;
  position: absolute;
  top: 20px;
  left: 0;
}

.L7fVLuP2sJBvah97Onl3 {
  font-size: 10px;
}
@media screen and (max-width: 1239px) {
  .ygbkTXBXF0PhToAdYYaC {
    margin: 10px;
    width: calc(100vw - 20px);
    border-bottom-right-radius: 20px;
    margin-top: 0;
    padding: 10px;
  }
}

@media screen and (max-width: 1024px) {
  .ygbkTXBXF0PhToAdYYaC {
    display: flex;
    /* align-content: space-between;} */
    flex-direction: column;
  }
  .Lr9TWq6bT4s8OQpG63cU {
    transform: translate(-50%, -50%);
  }
}

.vNd1F3l5h6xtK7_uFKgo {
  padding: 20px;
  overflow: auto;
}
.vNd1F3l5h6xtK7_uFKgo .cwqLUaP2t8dxSx8fbRkI {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}
.vNd1F3l5h6xtK7_uFKgo .Uj4slkJUzd2SyBXpjv7D {
  font-size: 16px;
  font-weight: 700;
}

.vNd1F3l5h6xtK7_uFKgo .R4AJq_l55u5X12mmii6W {
  color: var(--disabled-btn-bg);
  max-width: 46vw;
}
.vNd1F3l5h6xtK7_uFKgo .E1z0gn9_gg38s4SiFHvw {
  background-color: var(--background);
  padding: 16px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

@media screen and (max-width: 1000px) {
  .IxjdccRsag7UxKyF44FO {
    border-radius: 5px;
    border: 1px solid var(--doc-gray);
    flex-direction: column-reverse;
    height: max-content;
    margin: 20px auto;
    padding: 10px;
    width: 374px;
  }
}

@media screen and (max-width: 767px) {
  .ygbkTXBXF0PhToAdYYaC {
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    width: 100%;
  }
  .vNd1F3l5h6xtK7_uFKgo {
    flex-direction: column;
    justify-content: flex-start;
    padding: 10px;
    width: 100%;
  }
  .vNd1F3l5h6xtK7_uFKgo .cwqLUaP2t8dxSx8fbRkI {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .vNd1F3l5h6xtK7_uFKgo .Uj4slkJUzd2SyBXpjv7D {
    font-size: 14px;
  }
  .vNd1F3l5h6xtK7_uFKgo .R4AJq_l55u5X12mmii6W {
    font-size: 12px;
    max-width: 100%;
  }
  .vNd1F3l5h6xtK7_uFKgo .E1z0gn9_gg38s4SiFHvw {
    padding: 10px;
    border-radius: 20px;
    gap: 10px;
  }
}

/* ---------------------------- */
.DGbGLMgq8i9Tf23uWxBy {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.LkGAUGiy57a7A06owkHg {
  border: 0.5px solid var(--disabled-btn-bg);
  border-radius: 12px;
  padding: 12px;
  background-color: #fff;
  max-width: 28vw;
  width: 40vw;
  min-width: 440px;
}

.Usix8RNB0XIsp_903vKn {
  font-size: 14px;
  margin-bottom: 20px;
}

.TZ318L5Pt4ZvHe1B21BJ {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mC58aSzPkQ6G64hcytnD {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.advVUQ05fs4ZM3sKqF5C {
  color: var(--cadetGrey);
  font-weight: 500;
  flex: 1;
}
.afGE4t4S5DNIBsx85Lat {
  display: flex;
  gap: 2vw;
}

.mC58aSzPkQ6G64hcytnD {
  gap: 8px;
}
.mC58aSzPkQ6G64hcytnD .advVUQ05fs4ZM3sKqF5C {
  font-size: 12px;
}

.DAjO6BXdfmqf7msoZeDm {
  font-size: 14px;
  text-align: left;
  flex: 2;
  display: flex;
  justify-content: flex-start;
}
.za6MJOoD7kB89cy7935u {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  transition: color 0.2s ease;
  color: var(--disabled-btn-bg);
}

.za6MJOoD7kB89cy7935u:hover {
  color: var(--blue); 
}
/* ---------------------------- */
.igxBOLTpmNJo7Bl9BttZ {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.fm3YlhhoZrMSLxycckxm {
  display: flex;
  gap: 20px;
  /* margin-bottom: 10px; */
 
}
.Y73pImMf_mi162whT8IB {
  max-width: 28vw;
  display: flex;
  flex-direction: column;
}
.BGDKrRuyFZWc1jQvycIz {
  color: var(--disabled-btn-bg);
  max-width: 40vw;
}
@media screen and (max-width: 1024px) {
.Y73pImMf_mi162whT8IB {
  max-width: 50vw;
}

}
@media screen and (max-width: 767px) {
  .DGbGLMgq8i9Tf23uWxBy {
    gap: 0;
  }

  .fm3YlhhoZrMSLxycckxm {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    width: 100%;
    max-width: 100%;
  }
  .BGDKrRuyFZWc1jQvycIz {
    width: 100%;
    max-width: 100%;
  }
  .afGE4t4S5DNIBsx85Lat {
    display: flex;
    flex-direction: column-reverse;
    gap: 0;
    align-items: flex-end;
  }

  .Y73pImMf_mi162whT8IB {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    /* gap: 15px; */
  }
  .LkGAUGiy57a7A06owkHg {
    max-width: 100%;
    min-width: 100%;
    padding: 8px;
    height: max-content;
  }
  .DAjO6BXdfmqf7msoZeDm {
    font-size: 12px;
    flex: 1;
  }
}
/* ------------------------------------ */


.M4b6XwCT0LDIV1ityAzN {
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow: visible;
  max-height: calc(80vh - 170px);
  padding: 20px;
}

.jplp4Mjite2B9O7TkoLm {
  height: 100%;
  max-width: 98%;
  width: 100%;
}

.kr4t3YIFicEkSJK_KDQN {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.kuegTDh6Bdjfe3O221vf {
  font-size: 16px;
  margin-top: 30px;
}

.todSq2ozUJSLMnl9YTdg {
  overflow-y: auto;
  max-height: 260px;
}

.xLvLXRcPY1zd6_YBmeGN {
  display: flex;
  gap: 10px;
  margin: 20px;
}

@media screen and (max-width: 767px) {
  .U6XL8AaJmQecVvAWehQw {
    margin-bottom: 16px !important;
  }
  .M4b6XwCT0LDIV1ityAzN {
    flex-direction: column; 
    max-height: none;
    padding: 0;
    gap: 10px;
  }

  .jplp4Mjite2B9O7TkoLm {
    max-width: 100%;
  }

  .xLvLXRcPY1zd6_YBmeGN {
    gap: 12px;
    height: max-content;
      margin: 0;
    margin-top: 20px;

  }

  .kuegTDh6Bdjfe3O221vf {
    margin-top: 15px;
    font-size: 14px;
    text-align: left !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Docs/Docs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;;;;GAKG;AACH;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,mCAAmC;IACnC,sBAAsB;EACxB;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,iCAAiC;IACjC,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,WAAW;EACb;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,OAAO;AACT;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;;AAE3B;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;AACA;EACE,eAAe;AACjB;;AAEA;AACA;EACE;IACE,MAAM;EACR;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,MAAM;IACN,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,OAAO;EACT;AACF;AACA,yCAAyC;;;AAGzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;MACjB,SAAS;IACX,gBAAgB;;EAElB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;AACF","sourcesContent":[".wrapper {\n  padding: 12px;\n  padding-bottom: 2px;\n  width: calc(100% - var(--width-sidebar));\n  border-radius: 20px;\n  border-bottom-right-radius: 0px;\n  background-color: #fff;\n}\n\n.noDocs {\n  width: 275px;\n  text-align: end;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%);\n}\n\n/* .wrapper.mobile {\n    margin: 0 auto;\n    width: 100%;\n    padding: 0;\n    max-height: calc(100vh - 66px);\n} */\n.wrapper.mobile.sign {\n  padding-bottom: 20px;\n}\n\n.upload {\n  background-color: var(--red);\n  color: var(--white);\n  font-size: 14px;\n  /*font-weight: 700;*/\n  height: 60px;\n  margin: 10px auto;\n  width: 374px;\n  display: block;\n}\n\n.container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  width: 100%;\n  /* min-width: 660px; */\n  border-radius: 5px;\n  z-index: 0;\n}\n\n.filtr {\n  background-color: var(--white);\n  color: var(--red);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 195px;\n  height: 60px;\n  border: 1px solid var(--red);\n  border-radius: 5px;\n  margin: 10px 10px 10px 10px;\n  font-size: 14px;\n  line-height: 17px;\n  text-align: center;\n  padding: 0 42px;\n}\n.container:has(.filtr:only-child) {\n  justify-content: end;\n}\n\n.filtr {\n  padding: 0 20px;\n  min-width: 155px;\n}\n\n.filtr_icon {\n  position: relative;\n  width: 30px;\n  height: 20px;\n}\n.filtr_icon div {\n  border-top: 2px solid var(--red);\n}\n.filtr_icon div::before {\n  content: \"\";\n  border-top: 2px solid var(--red);\n  width: 20px;\n  position: absolute;\n  top: 10px;\n  left: 0;\n}\n.filtr_icon div::after {\n  content: \"\";\n  border-top: 2px solid var(--red);\n  width: 10px;\n  position: absolute;\n  top: 20px;\n  left: 0;\n}\n\n.type {\n  font-size: 10px;\n}\n@media screen and (max-width: 1239px) {\n  .wrapper {\n    margin: 10px;\n    width: calc(100vw - 20px);\n    border-bottom-right-radius: 20px;\n    margin-top: 0;\n    padding: 10px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .wrapper {\n    display: flex;\n    /* align-content: space-between;} */\n    flex-direction: column;\n  }\n  .noDocs {\n    transform: translate(-50%, -50%);\n  }\n}\n\n.settings {\n  padding: 20px;\n  overflow: auto;\n}\n.settings .bigLable {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.settings .middleLable {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.settings .middleText {\n  color: var(--disabled-btn-bg);\n  max-width: 46vw;\n}\n.settings .blockAttrEdit {\n  background-color: var(--background);\n  padding: 16px;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n@media screen and (max-width: 1000px) {\n  .signrow {\n    border-radius: 5px;\n    border: 1px solid var(--doc-gray);\n    flex-direction: column-reverse;\n    height: max-content;\n    margin: 20px auto;\n    padding: 10px;\n    width: 374px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .wrapper {\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 10px;\n    width: 100%;\n  }\n  .settings {\n    flex-direction: column;\n    justify-content: flex-start;\n    padding: 10px;\n    width: 100%;\n  }\n  .settings .bigLable {\n    font-size: 18px;\n    margin-bottom: 10px;\n  }\n  .settings .middleLable {\n    font-size: 14px;\n  }\n  .settings .middleText {\n    font-size: 12px;\n    max-width: 100%;\n  }\n  .settings .blockAttrEdit {\n    padding: 10px;\n    border-radius: 20px;\n    gap: 10px;\n  }\n}\n\n/* ---------------------------- */\n.attributesList {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.attributeCard {\n  border: 0.5px solid var(--disabled-btn-bg);\n  border-radius: 12px;\n  padding: 12px;\n  background-color: #fff;\n  max-width: 28vw;\n  width: 40vw;\n  min-width: 440px;\n}\n\n.cardTitle {\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.infoGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.label {\n  color: var(--cadetGrey);\n  font-weight: 500;\n  flex: 1;\n}\n.attrCardRow {\n  display: flex;\n  gap: 2vw;\n}\n\n.row {\n  gap: 8px;\n}\n.row .label {\n  font-size: 12px;\n}\n\n.value {\n  font-size: 14px;\n  text-align: left;\n  flex: 2;\n  display: flex;\n  justify-content: flex-start;\n}\n.iconBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  color: var(--disabled-btn-bg);\n}\n\n.iconBtn:hover {\n  color: var(--blue); \n}\n/* ---------------------------- */\n.option_wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n.blockBtn_settings {\n  display: flex;\n  gap: 20px;\n  /* margin-bottom: 10px; */\n \n}\n.input_settings {\n  max-width: 28vw;\n  display: flex;\n  flex-direction: column;\n}\n.options_info {\n  color: var(--disabled-btn-bg);\n  max-width: 40vw;\n}\n@media screen and (max-width: 1024px) {\n.input_settings {\n  max-width: 50vw;\n}\n\n}\n@media screen and (max-width: 767px) {\n  .attributesList {\n    gap: 0;\n  }\n\n  .blockBtn_settings {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n    max-width: 100%;\n  }\n  .options_info {\n    width: 100%;\n    max-width: 100%;\n  }\n  .attrCardRow {\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 0;\n    align-items: flex-end;\n  }\n\n  .input_settings {\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    /* gap: 15px; */\n  }\n  .attributeCard {\n    max-width: 100%;\n    min-width: 100%;\n    padding: 8px;\n    height: max-content;\n  }\n  .value {\n    font-size: 12px;\n    flex: 1;\n  }\n}\n/* ------------------------------------ */\n\n\n.editPopupContent {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  overflow: visible;\n  max-height: calc(80vh - 170px);\n  padding: 20px;\n}\n\n.inputColumn {\n  height: 100%;\n  max-width: 98%;\n  width: 100%;\n}\n\n.optionsSection {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.optionsTitle {\n  font-size: 16px;\n  margin-top: 30px;\n}\n\n.optionsEditorScroll {\n  overflow-y: auto;\n  max-height: 260px;\n}\n\n.buttonContainer {\n  display: flex;\n  gap: 10px;\n  margin: 20px;\n}\n\n@media screen and (max-width: 767px) {\n  .popupH {\n    margin-bottom: 16px !important;\n  }\n  .editPopupContent {\n    flex-direction: column; \n    max-height: none;\n    padding: 0;\n    gap: 10px;\n  }\n\n  .inputColumn {\n    max-width: 100%;\n  }\n\n  .buttonContainer {\n    gap: 12px;\n    height: max-content;\n      margin: 0;\n    margin-top: 20px;\n\n  }\n\n  .optionsTitle {\n    margin-top: 15px;\n    font-size: 14px;\n    text-align: left !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ygbkTXBXF0PhToAdYYaC`,
	"noDocs": `Lr9TWq6bT4s8OQpG63cU`,
	"mobile": `AhtQy7h_iVgVXdIACfqi`,
	"sign": `kesPQUxVsflEaVyl4p8p`,
	"upload": `YbiLv3VWhKzK9zhLcgbY`,
	"container": `stM99AFwYkqu4YcwtEbU`,
	"filtr": `U2v2fPUliNEE_FIVpeJv`,
	"filtr_icon": `css8Tcbnd_w80ZljjI81`,
	"type": `L7fVLuP2sJBvah97Onl3`,
	"settings": `vNd1F3l5h6xtK7_uFKgo`,
	"bigLable": `cwqLUaP2t8dxSx8fbRkI`,
	"middleLable": `Uj4slkJUzd2SyBXpjv7D`,
	"middleText": `R4AJq_l55u5X12mmii6W`,
	"blockAttrEdit": `E1z0gn9_gg38s4SiFHvw`,
	"signrow": `IxjdccRsag7UxKyF44FO`,
	"attributesList": `DGbGLMgq8i9Tf23uWxBy`,
	"attributeCard": `LkGAUGiy57a7A06owkHg`,
	"cardTitle": `Usix8RNB0XIsp_903vKn`,
	"infoGrid": `TZ318L5Pt4ZvHe1B21BJ`,
	"row": `mC58aSzPkQ6G64hcytnD`,
	"label": `advVUQ05fs4ZM3sKqF5C`,
	"attrCardRow": `afGE4t4S5DNIBsx85Lat`,
	"value": `DAjO6BXdfmqf7msoZeDm`,
	"iconBtn": `za6MJOoD7kB89cy7935u`,
	"option_wrapper": `igxBOLTpmNJo7Bl9BttZ`,
	"blockBtn_settings": `fm3YlhhoZrMSLxycckxm`,
	"input_settings": `Y73pImMf_mi162whT8IB`,
	"options_info": `BGDKrRuyFZWc1jQvycIz`,
	"editPopupContent": `M4b6XwCT0LDIV1ityAzN`,
	"inputColumn": `jplp4Mjite2B9O7TkoLm`,
	"optionsSection": `kr4t3YIFicEkSJK_KDQN`,
	"optionsTitle": `kuegTDh6Bdjfe3O221vf`,
	"optionsEditorScroll": `todSq2ozUJSLMnl9YTdg`,
	"buttonContainer": `xLvLXRcPY1zd6_YBmeGN`,
	"popupH": `U6XL8AaJmQecVvAWehQw`
};
export default ___CSS_LOADER_EXPORT___;
